<script setup lang="ts">

import {useAssetStore} from "@/stores/assetStore.ts";
import {useShipDesignCreationStore} from "@/stores/shipDesignCreationStore.ts";
import ShipDesignComponent from "@/components/Interface/Modal/Modals/ModalCreateShipDesign/ShipDesignComponent.vue";
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Stores / models
 */
const assetStore = useAssetStore()
const shipDesignStore = useShipDesignCreationStore()

/**
 * Props
 */
const props = defineProps({
  componentCode: {
    type: String,
    required: true
  },
  index: {
    type: Number,
    required: true
  }
});

/**
 * Variables
 */
const component = assetStore.findShipComponentByCode(props.componentCode)

</script>

<template>
  <ShipDesignComponent :component="component">
    <ActionButton
        @click="shipDesignStore.removeComponent(props.index)"
        :full-width="true">
      <span v-if="component.group === 'frame'">{{ t('command.shipDesigns.actions.resetDesign') }}</span>
      <span v-else>{{ t('common.actions.remove') }}</span>
    </ActionButton>
  </ShipDesignComponent>
</template>

<style scoped lang="scss">

</style>